import React, { useState, useContext, useEffect } from "react";
// mui
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/CustomInput";
import {
  Alert,
  AlertColor,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  Snackbar,
} from "@mui/material";
import theme from "../../global-styles/theme";
import { appLogger, Http } from "../../utils";
// import { useSelector } from "react-redux";
// import { IRootState } from "src/reducers";
import { ROLE_USER_ADMIN, UserInfo } from "../../model";
// import { Auth } from "aws-amplify";
// import jwtDecode from "jwt-decode";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { EmailOutlined } from "@mui/icons-material";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import images from "../../global-styles/images";
import { useNavigate } from "react-router-dom";
import FoundationIcon from "@mui/icons-material/Foundation";
import { enableRecaptcha, reCaptchaSiteKey } from "../../utils/config";
import { CheckCaptchValid, reCaptchaMandatoryMessage } from "../../utils/data";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { roleConfig } from "../../utils/config/role-config";
const recap_siteKey = reCaptchaSiteKey;
const env = process.env.REACT_APP_STAGE;

const initialValues: UserInfo = {
  active: true,
  createdBy: "",
  createdOn: new Date().getTime(),
  emailId: "",
  emailVerified: "false",
  id: "",
  nameFirst: "",
  nameLast: "",
  userRole: roleConfig[ROLE_USER_ADMIN],
  subOrg: "",
};

const validationSchema = Yup.object({
  nameFirst: Yup.string().required("First Name is required"),
  nameLast: Yup.string().required("Last Name is required"),
  emailId: Yup.string().email("Email is invalid").required("Email is required"),
  subOrg: Yup.string()
    .required("Organisation Name is required")
    .matches(
      /^[a-zA-Z0-9@]+$/,
      "This field cannot contain white space and special characters"
    ),
});
declare global {
  interface Window {
    grecaptcha: {
      render(
        arg0: string,
        arg1: { sitekey: { reCaptchaSiteKey: string }; size: string }
      ): unknown;
      enterprise: {
        ready(callback: () => any): any;
        execute(siteKey: string, options: any): any;
        // Add other methods or properties as needed
      };
      // Add other methods or properties as needed
    };
  }
}

const SignUp = (props: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<AlertColor>("success");
  const [newPassword, setNewPassword] = useState(false);
  const [userExist, setUserExist] = useState(false);
  const [termsCheck, setTermsCheck] = useState(false);
  // const stateVariable = useSelector((state: IRootState) => state);
  // const [superUserStateVariable, setSuperUserStateVariable] = useState(stateVariable);
  const [isLoading, setIsloading] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    let script: any;
    const style = document.createElement("style");
    // Define your CSS rules
    const cssRules = `
      .grecaptcha-badge {
        visibility: hidden;
  opacity: 0;
  width: 1px !important;
  height: 1px !important;
      }
    `;

    // Add CSS rules to the style element
    style.appendChild(document.createTextNode(cssRules));

    // Append the style element to the document head
    document.head.appendChild(style);
    const loadScript = () => {
      script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recap_siteKey}`;
      script.async = true;
      script.defer = true;
      script.id = "SignUp";

      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    };
    loadScript();
    return () => {
      // const scriptElem: any = document.getElementById("SOME_ID");
      // scriptElem.remove();
      if (scriptLoaded) {
        document.body.removeChild(script);
      }
    };
  }, [scriptLoaded]);

  const { setIsAuthenticated, userInfo, isAuthenticated } = useContext(
    UserContext
  ) as UserLoginInfo;

  const userInfoDetail = { user: userInfo };

  async function handleSignUp(values: UserInfo) {
    setUserExist(false);
    setIsloading(true);
    if (enableRecaptcha) {
      await window.grecaptcha.enterprise.ready(function () {
        window.grecaptcha.enterprise
          .execute(recap_siteKey, {
            action: "SIGN_UP",
          })
          .then(function (token: any) {
            // Handle the reCAPTCHA token
            if (token) {
              setIsloading(true);
              // Call your backend API to verify the reCAPTCHA token
              // Handle the form submission logic here
              Http.post({
                url: `/api/v2/recaptcha`,
                customHeaders: { noauthvalidate: "true" },
                state: userInfo,
                body: {
                  token: token,
                  expectedAction: "SIGN_UP",
                },
              })
                .then(async (response: any) => {
                  setIsloading(false);
                  const checkValidData: any = CheckCaptchValid(
                    response?.message
                  );
                  if (checkValidData) {
                    const parsedData = JSON.parse(checkValidData);
                    if (parsedData && parsedData.valid) {
                      confirmSignupAuth(values);
                    } else {
                      props.snackbarShowMessage(
                        "Captcha verification failed",
                        "error"
                      );
                    }
                  } else {
                    props.snackbarShowMessage(
                      "Captcha verification failed",
                      "error"
                    );
                  }
                })
                .catch((error) => {
                  appLogger.error({
                    errObj: {
                      method: "regenerateApiKey",
                      component: "signup",
                      fileName: "home.tsx",
                      err: error,
                    },
                  });
                  setIsloading(false);
                });
            } else {
              props.snackbarShowMessage("Captcha verification failed");
              setIsloading(false);
              // console.error("Captcha verification failed");
            }
          })
          .catch(function (error: any) {
            setIsloading(false);
            props.snackbarShowMessage("Error executing reCAPTCHA:", "error");
            // console.error("Error executing reCAPTCHA:", error);
          });
      });
    } else {
      confirmSignupAuth(values);
    }
  }
  const confirmSignupAuth = (values: any) => {
    setIsloading(true);
    const data = { ...values };
    data.emailId = data.emailId.toLowerCase();
    try {
      Http.post({
        url: `/api/v2/users/signup`,
        body: {
          ...data,
        },
        state: { userInfoDetail },
        customHeaders: { noauthvalidate: "true" },
      })
        .then((response: any) => {
          setIsloading(false);
          appLogger.info({
            infoObj: {
              method: "handleSignUp",
              component: "signUp",
              fileName: "index.tsx",
              response: response,
            },
          });
          if (response && response.message && response.message.isOrgExist) {
            formik.setErrors({
              subOrg:
                "Organisation with the given name already exists. Please contact your administrator to join this organisation. You may alternatively register with a different organisation name.",
            });
          } else {
            setNewPassword(true);
          }
        })
        .catch((err) => {
          setIsloading(false);
          appLogger.error({
            errObj: {
              method: "handleSignUp",
              component: "signUp",
              fileName: "index.tsx",
              err: err,
            },
          });
          setUserExist(true);
        });
    } catch (error) {
      setIsloading(false);
      appLogger.error({
        errObj: {
          method: "handleSignUp",
          component: "signUp",
          fileName: "index.tsx",
          err: error,
        },
      });
    }
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSignUp,
  });

  const handleClose = () => {
    setOpen(false);
  };

  const termsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTermsCheck(event.target.checked);
  };

  useEffect(() => {}, [termsCheck]);

  return (
    <Box
      component="div"
      className={isLoading ? "loader auth-form" : "auth-form"}
    >
      <Container component="div" className="form-container">
        <Box className="logo-wrap">
          <img src={images.logoBlack} alt="Cuvo Logo" />
        </Box>
        <Box className="form-wrap">
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          {!newPassword ? (
            <Box
              component="form"
              noValidate
              onSubmit={formik.handleSubmit}
              method="post"
            >
              <CustomInput
                autoComplete="given-name"
                placeholder="Enter First Name"
                id="firstName"
                label="First Name"
                autoFocus={true}
                startAdornment={
                  <InputAdornment position="start">
                    <PermIdentityIcon />
                  </InputAdornment>
                }
                {...formik.getFieldProps("nameFirst")}
                error={
                  (formik.values.nameLast ||
                    (formik.values.emailId && !formik.values.nameFirst)) &&
                  formik.touched.nameFirst &&
                  formik.errors.nameFirst
                    ? true
                    : false
                }
                helperText={
                  formik.values.nameLast ||
                  (formik.values.emailId &&
                    formik.touched.nameFirst &&
                    formik.errors.nameFirst)
                    ? formik.errors.nameFirst
                    : null
                }
              />
              <CustomInput
                id="lastName"
                placeholder="Enter Last Name"
                label="Last Name"
                autoComplete="family-name"
                {...formik.getFieldProps("nameLast")}
                startAdornment={
                  <InputAdornment position="start">
                    <PermIdentityIcon />
                  </InputAdornment>
                }
                error={
                  formik.touched.nameLast && formik.errors.nameLast
                    ? true
                    : false
                }
                helperText={
                  formik.touched.nameLast && formik.errors.nameLast
                    ? formik.errors.nameLast
                    : null
                }
              />

              <CustomInput
                id="emailId"
                placeholder="Enter Email Address"
                label="Email Address"
                autoComplete="emailId"
                {...formik.getFieldProps("emailId")}
                startAdornment={
                  <InputAdornment position="start">
                    <EmailOutlined />
                  </InputAdornment>
                }
                error={
                  formik.touched.emailId && formik.errors.emailId ? true : false
                }
                helperText={
                  formik.touched.emailId && formik.errors.emailId
                    ? formik.errors.emailId
                    : null
                }
              />

              <CustomInput
                placeholder="Organisation Name"
                label="Organisation Name"
                id="organizationName"
                startAdornment={
                  <InputAdornment position="start">
                    <FoundationIcon />
                  </InputAdornment>
                }
                {...formik.getFieldProps("subOrg")}
                error={
                  formik.touched.subOrg && formik.errors.subOrg ? true : false
                }
                helperText={
                  formik.touched.subOrg && formik.errors.subOrg
                    ? formik.errors.subOrg
                    : null
                }
              />

              {userExist && (
                <Typography className="error-msg">
                  user already exists
                </Typography>
              )}
              <FormControlLabel
                sx={{ mb: 1 }}
                control={
                  <Checkbox
                    onChange={termsChange}
                    value={termsCheck}
                    color="primary"
                  />
                }
                className="remember-label"
                label={
                  <Typography>
                    I agree to the&nbsp;
                    <a href="https://www.cuvo.io/privacy" target="_blank">
                      Privacy Policy
                    </a>
                    &nbsp;and&nbsp;
                    <a
                      href="https://www.cuvo.io/customer-terms-of-services"
                      target="_blank"
                    >
                      Terms and Conditions
                    </a>
                    &nbsp;of this site.
                  </Typography>
                }
              />
              {reCaptchaMandatoryMessage()}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: "15px",
                  mb: "15px",
                  backgroundColor: (theme: any) => theme.palette.primary.main,
                  textTransform: "uppercase",
                }}
                disabled={!(formik.isValid && formik.dirty) || !termsCheck}
              >
                Sign Up
              </Button>
              <Grid container justifyContent="center">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="signup-link"
                >
                  <Typography component="p">
                    Already have an account?
                  </Typography>
                  <Link
                    href="/"
                    color="secondary"
                    sx={{
                      color: theme.palette.primary.main,
                      textDecoration: "none",
                    }}
                  >
                    {"Sign In"}
                  </Link>
                </Box>
                {/* <Link href='/sign-in' variant='body2'>
									Already have an account? Sign in
								</Link> */}
              </Grid>
            </Box>
          ) : (
            <Grid container justifyContent="center">
              <Box
                sx={{
                  textAlign: "center",
                }}
                className="temp-info"
              >
                <Typography component="p">
                  We have sent you a temporary password at the email address you
                  provided in the form. <br />
                  Please get the temporary password from your email and click
                  sign in to continue.
                </Typography>
                <Link
                  href="/"
                  color="secondary"
                  sx={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                    pl: 1,
                    fontSize: "14px",
                    textTransform: "uppercase",
                  }}
                >
                  {"Sign In"}
                </Link>
              </Box>
            </Grid>
          )}
        </Box>
      </Container>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        open={open}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity ? severity : "success"}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default withSnackbar(SignUp);
